export default {"src":"/_next/static/media/uor-logo.55f1f3ca.svg","height":68,"width":122,"blurWidth":0,"blurHeight":0};